// extracted by mini-css-extract-plugin
export var fadeIn = "_8z-0";
export var panelInner = "_8z-2";
export var panelOuter = "_8z-1";